import { Navigate, useParams } from 'react-router-dom';
import AppShell from '../components/work/AppShell';
import { DoneSection } from '../components/work/DoneSection';
import Peek from '../components/work/Peek';
import { PageTitle } from '../components/work/page-states';

export function ArchivesRedirect() {
  const { projectId } = useParams<{ projectId: string }>();
  return <Navigate to={projectId ? `/projects/${projectId}/completed` : '/projects'} replace />;
}

/** A stream's tasks that have been marked done. */
export default function Archives() {
  const { projectId } = useParams<{ projectId: string }>();
  if (!projectId) return <div className="p-6 text-sm text-muted-foreground">Missing stream.</div>;

  return (
    <AppShell projectId={projectId}>
      <div className="flex flex-1 flex-col gap-4">
        <PageTitle title="Completed" />
        <DoneSection scope={{ projectId }} empty="Nothing completed yet." />
        <Peek projectId={projectId} />
      </div>
    </AppShell>
  );
}
